import type { RoomInfo } from '@/app/(pages)/results/type';
import { useEffect } from 'react';
import { setCookie } from 'cookies-next/client';
import { DEFAULT_COOKIE_OPTIONS, CookieKey } from '@/app/(pages)/results/constants';

export const useSyncCookies = ({
  checkInDate,
  checkOutDate,
  capacityAdult,
  capacityChild,
  capacityChildAges,
  globalCheckInDate,
  globalCheckOutDate,
  globalCapacityRooms,
}: {
  checkInDate: string;
  checkOutDate: string;
  capacityAdult: number;
  capacityChild: number;
  capacityChildAges: number[];
  globalCheckInDate: string;
  globalCheckOutDate: string;
  globalCapacityRooms: RoomInfo[];
}) => {
  useEffect(() => {
    setCookie(CookieKey.CHECK_IN_OUT_DOMESTIC, JSON.stringify([checkInDate, checkOutDate]), DEFAULT_COOKIE_OPTIONS);
  }, [checkInDate, checkOutDate]);

  useEffect(() => {
    setCookie(
      CookieKey.CAPACITY_DOMESTIC,
      JSON.stringify([capacityAdult, capacityChild, capacityChildAges]),
      DEFAULT_COOKIE_OPTIONS,
    );
  }, [capacityAdult, capacityChild, capacityChildAges]);

  useEffect(() => {
    setCookie(
      CookieKey.CHECK_IN_OUT_GLOBAL,
      JSON.stringify([globalCheckInDate, globalCheckOutDate]),
      DEFAULT_COOKIE_OPTIONS,
    );
  }, [globalCheckInDate, globalCheckOutDate]);

  useEffect(() => {
    setCookie(
      CookieKey.CAPACITY_GLOBAL,
      JSON.stringify(globalCapacityRooms.map(({ adult, child }) => [adult, child.length, child])),
      DEFAULT_COOKIE_OPTIONS,
    );
  }, [globalCapacityRooms]);
};
